import * as React from 'react';
import Assessment from '@material-ui/icons/Assessment';
import Details from '@material-ui/icons/Details'
import LocalCarWash from '@material-ui/icons/LocalCarWash';
import DashBoard from '@material-ui/icons/Dashboard';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import Router from '@material-ui/icons/Router';
import PieChart from '@material-ui/icons/PieChart';
import Edit from '@material-ui/icons/Edit';
import Home from '@material-ui/icons/Home';
import AddBox from '@material-ui/icons/AddBox';
import AccountBalance  from '@material-ui/icons/AccountBalance'
import AccountBoxRounded from '@material-ui/icons/AccountBoxRounded';
import Gavel from '@material-ui/icons/Gavel';
import List from '@material-ui/icons/List';
import AddCircle from '@material-ui/icons/AddCircle';
import Filter from '@material-ui/icons/FilterCenterFocus';
import DoubleArrow from '@material-ui/icons/DoubleArrow';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import { SvgIcon } from '@material-ui/core';
import ContactSupport from '@material-ui/icons/ContactSupport';
import BugReport from '@material-ui/icons/BugReport';
import SupervisorAccount from '@material-ui/icons/SupervisorAccount';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
/*
This isn't my favorite pattern, but it does help to reduce the size of the bundle
by limiting the icons we include.  Any component should use this for icons.
*/

export enum SupportedIcons {
    
    DashBoard = 1,
    Details = 2,
    LocalCarWash = 3,
    SupervisedUseCircleIcon = 4,
    Assessment = 5,
    Router = 6,
    PieChart = 7,
    Edit = 8,
    Home = 9,
    AddBox = 10,
    Legacy_Dashboard = 11,
    Member = 12,
    MemberMisUse = 13,
    QueryList = 14,
    WashX = 15,
    Support = 16,
    Testing = 17,
    Admin = 18,
    AddCircle = 19,
    DoubleArrow = 20,
    ArrowDownward = 21,
    InfoOutlined = 22,
    Filter = 23
};

interface Props {
    iconName: SupportedIcons;
    [propName: string]: any;
};

const iconList = [
    { key: SupportedIcons.DashBoard, getIcon: (props: any) => { return (<DashBoard {...props}/> )} },
    { key: SupportedIcons.Details, getIcon: (props: any) => { return (<Details {...props}/> )} },
    { key: SupportedIcons.LocalCarWash, getIcon: (props: any) => { return (<LocalCarWash {...props}/> )} },
    { key: SupportedIcons.SupervisedUseCircleIcon, getIcon: (props: any) => { return (<SupervisedUserCircleIcon {...props}/> )} },
    { key: SupportedIcons.Assessment, getIcon: (props: any) => { return (<Assessment {...props}/> )} },
    { key: SupportedIcons.Router, getIcon: (props: any) => { return (<Router {...props}/> )} },
    { key: SupportedIcons.PieChart, getIcon: (props: any) => { return (<PieChart {...props}/> )} },
    { key: SupportedIcons.Edit, getIcon: (props: any) => { return (<Edit {...props}/> )} },
    { key: SupportedIcons.Home, getIcon: (props: any) => { return (<Home {...props}/> )} },
    { key: SupportedIcons.AddBox, getIcon: (props: any) => { return (<AddBox {...props}/> )} },
    { key: SupportedIcons.Legacy_Dashboard, getIcon: (props: any) => { return (<AccountBalance {...props}/> )} },
    { key: SupportedIcons.Member, getIcon: (props: any) => { return (<AccountBoxRounded {...props}/> )} },
    { key: SupportedIcons.MemberMisUse, getIcon: (props: any) => { return (<Gavel {...props}/> )} },
    { key: SupportedIcons.Admin, getIcon: (props: any) => { return (<SupervisorAccount {...props}/> )} },
    { key: SupportedIcons.QueryList, getIcon: (props: any) => { return (<List {...props}/> )} },
    { key: SupportedIcons.AddCircle, getIcon: (props: any) => { return (<AddCircle {...props}/> )} },
    { key: SupportedIcons.DoubleArrow, getIcon: (props: any) => { return (<DoubleArrow {...props}/> )} },
    { key: SupportedIcons.ArrowDownward, getIcon: (props: any) => { return (<ArrowDownward {...props}/> )} },
    { key: SupportedIcons.WashX, getIcon: (props: any) => {  
        return (
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="19" height="32" viewBox="0 0 19 32">
                <title>washx</title>
                <path fill="#27aae1" stroke="#27aae1" strokeLinejoin="miter" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="3.1123" d="M1.556 22.442l16.107-20.886"></path>
                <path fill="#27aae1" stroke="#27aae1" strokeLinejoin="miter" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="3.1123" d="M1.664 9.559l16.107 20.885"></path>
            </svg>
            )
        }
    },
    { key: SupportedIcons.Support, getIcon: (props: any) => { return (<ContactSupport {...props}/> )} },
    { key: SupportedIcons.Testing, getIcon: (props: any) => { return (<BugReport {...props}/> )} },
    { key: SupportedIcons.InfoOutlined, getIcon: (props: any) => { return (<InfoOutlined {...props}/> )} },
    { key: SupportedIcons.Filter, getIcon: (props: any) => { return (<Filter {...props}/> )} },
]

const GetIcon = (props: Props) => {
    let fn = iconList.filter(e => { return e.key === props.iconName })[0];

    // Remove iconName from the props so that the console stops throwing errors.
    const { iconName, ...newProps } = props;    
    return fn.getIcon(newProps);
}

const Icon: React.FC<Props> = (props: Props) => {

    return ( GetIcon(props) );
}

export default Icon;

